import BaseModel from './BaseModel'
import {action, computed, makeObservable, observable, reaction} from 'mobx'
import {isValidPhoneNumber} from 'libphonenumber-js'
import {post} from '../common/requester'
import Schedule from "./Schedule";

export default class BillingQuery extends BaseModel {
  constructor(store) {
    super(store);
    makeObservable(this, {
      page_number: observable,
      page_count: observable,
      page_size: observable,
      count: observable,
      company_user_id: observable,
      date_from: observable,
      date_to: observable,
      billing_type_id: observable,
      object_id: observable,
      payment_method: observable,
      is_paid: observable,
      is_approved: observable,
      title: observable,
      total: observable,
    })
  }

  page_number = 1;
  page_count = 1;
  page_size = 30;
  count = 0;
  company_user_id = 0;
  date_from = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  date_to = new Date();
  billing_type_id = 0;
  object_id = 0;
  payment_method = '';
  is_paid = null;
  is_approved = null;
  title='';
  total = 0;
}